// Third party
import * as yup from 'yup';
import dayjs, { Dayjs } from 'dayjs';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const CreateUpdateManagedUserSchema = yup.object({
  username: yup.string().required(''),
  email: yup.string().email('Invalid email').required(''),
  password: yup.string().when('$isEdit', {
    is: false,
    then: (schema) => schema.required(''),
    otherwise: (schema) => schema.notRequired()
  }),
  first_name: yup.string().required(''),
  last_name: yup.string().required(''),
  phone: yup.string().required(''),
  account_root_id: yup.number().min(1, '').required(),
  date_of_birth: yup
    .mixed<Dayjs>()
    .required('')
    .test('is-valid', 'Invalid date', (value) => dayjs.isDayjs(value) && value.isValid?.())
    .test(
      'is-18',
      'User must be at least 18 years old',
      (value) => dayjs.isDayjs(value) && dayjs().diff(value, 'year') >= 18
    ),
});

export { CreateUpdateManagedUserSchema };